module.exports = "<app-technical-menu></app-technical-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/technical.component.html
// module id = ./src/app/technical/technical.component.html
// module chunks = main